import { Theme } from './theme';

/**
 * Contains keys for the dark version of this application
 */
export const darkTheme: Theme = {
  'aside-background': 'bg-public-menu',
  'aside-text': 'text-public-text',
  'body-background': 'bg-public-background',
  'content-background': 'bg-dark-contentBackground',
  link: 'text-public-textHighlight hover:text-dark-linkHover focus:text-dark-linkHover',
  text: 'text-public-text',
  'card-background': 'bg-public-menu',
  'card-text': 'text-public-textHighlight',
  'heading-text': 'text-public-textHighlight',
  'divider-color': 'border-dark-dividerColor',
  'divide-color': 'divide-gray-800',
  'main-menu-width': 'w-publicMenu',
  'main-menu-item-hover': '',
  'label-text': 'text-dark-labelColor',
  'table-border': 'border-dark-dividerColor',
  'table-header-text': 'text-public-textHighlight',
  'table-row-hover': 'hover:bg-public-menu',
  'table-row-edit': 'bg-public-menu',
  'table-button-hover': 'hover:text-public-textHighlight',
  'info-background': 'bg-gray-900',
  'active-pill': 'bg-public-textHighlight text-public-background',
  'inactive-pill': 'hover:bg-gray-700',
  'secondary-text': 'text-public-text',
  'drop-border': 'border-public-menu',
  'secondary-heading-text': 'text-public-textHighlight',
  'language-link': 'text-gray-400 hover:text-public-textHighlight',
  'aside-link': 'text-public-textHighlight hover:text-dark-linkHover focus:text-dark-linkHover',
  'messagebar-info': 'border-blue-800 bg-blue-900',
  'messagebar-error': 'border-red-800 bg-red-900',
  charttheme: 'dark',
  'charttheme-internal': 'dark',
  'landing-menu': 'bg-dark-landingMenuBackground',

  themeName: 'dark',
};
